<template>
  <div>
    <button @click="print">
      <Icon
        icon="heroicons:printer-solid"
        class="h-4 w-4 text-gray-900"
      />
    </button>
    <vue-html2pdf
      v-if="order"
      :show-layout="false"
      :float-layout="true"
      :preview-modal="true"
      :enable-download="false"
      :filename="order.attributes.origin_code"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="printStockMovement"
    >
      <LayoutPrintStockMovement
        slot="pdf-content"
        :single-packet="{ code: packet.attributes.code, name: packet.attributes.name }"
        :stock-movement="printStockMovementAttributes"
        :total-packet="getIncludedByType(stockMovement, 'packets').length"
      />
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import LayoutPrintStockMovement from '@/layouts/LayoutPrintStockMovement.vue';
import dayjs from 'dayjs';
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  components: {
    VueHtml2pdf,
    LayoutPrintStockMovement
  },
  props: {
    stockMovement: Object,
    order: Object,
    packet: Object
  },
  data() {
    return {
      details: {
        data: []
      }
    }
  },
  computed: {
    printStockMovementAttributes() {
      const destinationOfficeRel =
        this.stockMovement.data.relationships['destination-office'].data;
      const destinationOffice = destinationOfficeRel
        ? this.getSingleIncluded(this.stockMovement, destinationOfficeRel.id)
        : null;
      return {
        code: this.stockMovement.data.attributes.code,
        date: dayjs(this.stockMovement.data.attributes.updatedAt).format('ll LT'),
        order: {
          code: `${this.order.attributes.origin_code}/${this.order.attributes.destination_code}`,
          destinationOffice: destinationOffice
            ? destinationOffice.attributes.code
            : '-',
          address: this.order.attributes.complete_shipment_address,
          structuredAddress: this.order.attributes.structured_complete_shipment_address,
          name:
            this.order.attributes.receipt_name ||
            destinationOffice.attributes.name,
          phone:
            this.order.attributes.receipt_phone ||
            destinationOffice.attributes.cellphone,
        },
        packets: {
          code: this.packet.attributes.code,
          name: this.packet.attributes.name,
          products: this.details.data.map((product) => ({
            shipped_product_qty: product.attributes.shipped_product_qty,
            type: product.attributes.product_type,
            product_name: product.attributes.product_name,
          })),
        },
      };
    }
  },
  methods: {
    async print() {
      const [res, err] = await this.request(`/api/v1/packets/${this.packet.id}/movement-details`)

      if (!err) {
        this.details = res

        setTimeout(() => {
          this.$refs.printStockMovement.generatePdf();
        }, 0);
      }
    }
  }
}
</script>
